<div
  class="page-top-breadcrumb"
  fxLayout="row" fxLayoutGap="5px" fxLayoutAlign="start center"
  *ngIf="finfraStudioPageTopBreadcrumbService.showBreadCrumb">
  <ng-container *ngFor="let data of finfraStudioPageTopBreadcrumbService.breadCrumb; let idx = index">
    <ng-container *ngIf="idx !== 0">&nbsp;/&nbsp;</ng-container>
    <span *ngIf="data && data.length === 1">{{data[0]?.value}}</span>
    <span *ngIf="data && data.length === 2">{{data[0]?.value || data[1]?.value}}</span>
  </ng-container>
  <ng-container *ngIf="finfraStudioPageTopBreadcrumbService.breadCrumb.length === 0">
    <span>-</span>
  </ng-container>
  <span>&nbsp;|&nbsp;</span>
</div>
